import { useEffect } from "react";
import { useSelectionStore } from "../../stores/selectionStore";

export function useSceneGraphSelectionPruning({
  bodies,
  meshes,
  sites,
  joints,
  setMultiSelectedMeshes,
  setMultiSelectedGeoms,
  setMultiSelectedSites,
  setMultiSelectedInertials,
  setMultiSelectedJoints,
}) {
  useEffect(() => {
    const validBodyUuids = new Set(Object.keys(bodies || {}));
    const current = useSelectionStore.getState().selectedBodies;
    const next = current.filter((uuid) => validBodyUuids.has(uuid));
    if (next.length !== current.length) {
      useSelectionStore.getState().setSelectedBodies(next);
    }
  }, [bodies]);

  useEffect(() => {
    const validMeshIds = new Set(Object.keys(meshes || {}));
    setMultiSelectedMeshes((prev) => {
      const next = new Set([...prev].filter((meshId) => validMeshIds.has(meshId)));
      return next.size === prev.size ? prev : next;
    });
  }, [meshes, setMultiSelectedMeshes]);

  useEffect(() => {
    const validGeomKeys = new Set();
    Object.values(bodies || {}).forEach((body) => {
      if (!body?.uuid || !Array.isArray(body.geoms)) return;
      body.geoms.forEach((geom) => {
        if (geom?.visualOnly === true || !geom?.uuid) return;
        validGeomKeys.add(`${body.uuid}:${String(geom.uuid)}`);
      });
    });
    setMultiSelectedGeoms((prev) => {
      const next = new Set([...prev].filter((geomKey) => validGeomKeys.has(geomKey)));
      return next.size === prev.size ? prev : next;
    });
  }, [bodies, setMultiSelectedGeoms]);

  useEffect(() => {
    const validSiteIds = new Set(Object.keys(sites || {}));
    setMultiSelectedSites((prev) => {
      const next = new Set([...prev].filter((siteId) => validSiteIds.has(siteId)));
      return next.size === prev.size ? prev : next;
    });
  }, [sites, setMultiSelectedSites]);

  useEffect(() => {
    const validInertialKeys = new Set();
    Object.values(bodies || {}).forEach((body) => {
      if (!body?.uuid || !body?.inertia?.uuid) return;
      validInertialKeys.add(`${body.uuid}:${String(body.inertia.uuid)}`);
    });
    setMultiSelectedInertials((prev) => {
      const next = new Set([...prev].filter((key) => validInertialKeys.has(key)));
      return next.size === prev.size ? prev : next;
    });
  }, [bodies, setMultiSelectedInertials]);

  useEffect(() => {
    const validJointIds = new Set(Object.keys(joints || {}));
    setMultiSelectedJoints((prev) => {
      const next = new Set([...prev].filter((jointId) => validJointIds.has(jointId)));
      return next.size === prev.size ? prev : next;
    });
  }, [joints, setMultiSelectedJoints]);
}
